export default __webpack_public_path__ + "static/media/behance.8a2b476a.svg";